import { Injectable } from '@angular/core';
import { AuthService } from '../auth.service';
import { Observable } from 'rxjs';
import {BookVersionIntegrationModel, BookVersionModel} from '../../models/edu-admin/book-version.model';
import { map } from 'rxjs/operators';
import {StringExtensionModel} from '../../models/extensions/string-extension.model';

@Injectable({
  providedIn: 'root'
})
export class AdminBookVersionService {

  constructor(private authSv: AuthService) { }

  fetchBookVersions(bookId: string): Observable<BookVersionModel[]> {

    return this.authSv.get('/books/' + bookId + '/versions').pipe(map((response) => {

      const bookVersions = BookVersionModel.generateModels(response.data);
      return bookVersions;

    }));

  }

  fetchBookVersionById(bookId: string, versionId: string): Observable<BookVersionModel> {

    return this.authSv.get('/books/' + bookId + '/versions/' + versionId).pipe(map((response) => {

      const bookVersion = BookVersionModel.generateModel(response.data);
      return bookVersion;

    }));

  }

  copyBookVersion(version: BookVersionModel, bookId: string) {

    const url = '/books/' + bookId + '/versions/' + version._id + '/copy';

    return this.authSv.get(url).pipe(map((response) => {
      const bookVersion = BookVersionModel.generateModel(response.data);

      return bookVersion;

    }));

  }

  createBookVersion(version: BookVersionModel, bookId: string): Observable<BookVersionModel> {

    return this.authSv.post('/books/' + bookId + '/versions', version).pipe(map((response) => {

      const bookVersion = BookVersionModel.generateModel(response.data);
      return bookVersion;

    }));

  }

  updateBookVersion(version: BookVersionModel, bookId: string): Observable<BookVersionModel> {

    return this.authSv.patch('/books/' + bookId + '/versions/' + version._id, version).pipe(map((response) => {

      const bookVersion = BookVersionModel.generateModel(response.data);
      return bookVersion;

    }));
  }

  deleteBookVersion(bookId: string, versionId: string): Observable<BookVersionModel> {

    return this.authSv.delete('/books/' + bookId + '/versions/' + versionId).pipe(map((response) => {

      const bookVersion = BookVersionModel.generateModel(response.data);
      return bookVersion;

    }));

  }

  fetchIntegrationById(bookId: string, versionId: string, integrationId: string, includeQuestions = false, translationForCulture = false): Observable<BookVersionIntegrationModel> {

    let url = `/books/${bookId}/versions/${versionId}/integrations/${integrationId}`;
    url += StringExtensionModel.queryString({ includeQuestions, translationForCulture });

    return this.authSv.get(url).pipe(map((response) => {

      const integration = BookVersionIntegrationModel.generateModel(response.data);
      return integration;

    }));

  }

  updateIntegrationById(integration: BookVersionIntegrationModel, bookId: string, versionId: string): Observable<BookVersionIntegrationModel> {

    return this.authSv.patch(`/books/${bookId}/versions/${versionId}/integrations/${integration._id}`, integration).pipe(map((response) => {

      const updatedIntegration = BookVersionIntegrationModel.generateModel(response.data);
      return updatedIntegration;

    }));

  }

}
